import * as React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface SuspendUserConfirmationModalProps {
  suspendMultiple: boolean;
  onRequestClose: () => void;
  onSuspend: () => void;
  warningText?: string;
}

export function SuspendUserConfirmationModal(props: SuspendUserConfirmationModalProps): JSX.Element {
  const buttonText = `Suspend ${props.suspendMultiple ? 'these users' : 'this user'}`;
  return (
    <Modal
      onRequestClose={props.onRequestClose}
      title="Suspend users?"
      buttons={[
        {
          text: buttonText,
          style: ButtonStyle.NEGATIVE,
          onClick: () => {
            props.onSuspend();
            props.onRequestClose();
          },
          dataTestAttrs: {
            component: 'Modal',
            element: 'footerButton',
            key: 'confirmSuspend',
          },
        },
      ]}
      footer={<span className="u-faded"> {props.warningText} </span>}
      footerPullRight={true}
    >
      <div>
        <p>Users will be logged out of current sessions and locked out of Benchling.</p>
      </div>
    </Modal>
  );
}
